import {ClipboardCheck, Lock, Search} from 'lucide-react'
import FadeIn from '@/components/FadeIn'

const steps = [
  {
    icon: Search,
    number: '01',
    title: 'Aquisição',
    description: 'Identificamos e adquirimos projetos digitais consolidados, com audiência e histórico relevantes.',
  },
  {
    icon: ClipboardCheck,
    number: '02',
    title: 'Curadoria e avaliação',
    description: 'Analisamos cada ativo com critério, preparando-o para encontrar o novo dono ideal.',
  },
  {
    icon: Lock,
    number: '03',
    title: 'Transferência segura',
    description: 'Conduzimos toda a negociação com o novo proprietário de forma sigilosa e segura, do início ao fim.',
  },
]

function HowItWorks() {
  return (
    <section className="py-16 sm:py-20 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <FadeIn className="max-w-2xl">
          <span className="text-xs font-semibold tracking-widest text-blue-600 uppercase">Processo</span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-slate-950">
            Como funciona
          </h2>
        </FadeIn>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-5">
          {steps.map((step, index) => (
            <FadeIn key={step.number} delay={index * 100} className="h-full">
              <div className="relative h-full bg-white rounded-2xl border border-slate-200 p-7 sm:p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-blue-400/50 hover:shadow-xl hover:shadow-blue-500/15">
                <div className="flex items-center justify-between">
                  <span className="text-3xl font-extrabold text-blue-600 tracking-tight">{step.number}</span>
                  <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-600 to-blue-900 shadow-md shadow-blue-600/30">
                    <step.icon className="w-5 h-5 text-white" strokeWidth={1.5} />
                  </div>
                </div>
                <div className="mt-5 h-px w-full bg-slate-100" />
                <h3 className="mt-5 text-lg font-semibold text-slate-950 tracking-tight">
                  {step.title}
                </h3>
                <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HowItWorks
